import {createSelector} from 'reselect';
import {getPlan, getWeekNumber} from '../../App/selectors';

export const selectPlan = createSelector([getPlan], plan => plan.toJS());
export const selectWeekNumber = createSelector([getWeekNumber], weekNumber => weekNumber);
